// frontend/shared-ui/src/components/MarginBadge.jsx
import React from "react";
import { computeMargin, formatPercent, marginTier } from "../utils/money";

const TIER_CLASS = {
  healthy: "fh-margin-badge--healthy",
  okay: "fh-margin-badge--okay",
  thin: "fh-margin-badge--thin",
  loss: "fh-margin-badge--loss",
  unknown: "fh-margin-badge--unknown",
};

/**
 * <MarginBadge price={22000} cost={12000} />
 * <MarginBadge value={45.5} />
 */
export default function MarginBadge({
  price,
  cost,
  value,
  label,
  showIcon = true,
  className = "",
}) {
  const margin =
    value !== undefined ? Number(value) : computeMargin(price, cost);
  const tier = marginTier(margin);

  const icons = {
    healthy: "▲",
    okay: "●",
    thin: "▼",
    loss: "⚠",
    unknown: "?",
  };

  return (
    <span
      className={`fh-margin-badge ${TIER_CLASS[tier]} ${className}`}
      title={label || "Margin"}
    >
      {showIcon && <span className="fh-margin-badge__icon">{icons[tier]}</span>}
      {formatPercent(margin)}
    </span>
  );
}
